import React from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'

import { LogoutButton } from '@sputnik/components'
import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import AfterSubmitInfoPageLayout from '@sputnik/pages/PostApplicationPages/AfterSubmitInfoPageLayout'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const WorkingOutDetails = () => {
  const [getClassName] = useNameFormatter('WorkingOutDetails')
  const { formatMessage } = useIntl()
  const { track } = useWebTracking()

  useDidMount(() => {
    track('se_signup__application_working_out_details__presented')
  })

  return (
    <AfterSubmitInfoPageLayout
      buttons={
        <>
          <GoToDashboardButton
            componentName={getClassName('')}
            onClick={() => {
              track('se_signup__application_working_out_details_go_to_dashboard__fired')
            }}
          />
          <LogoutButton
            buttonType={BASIC_BUTTON_TYPE_OUTLINED}
            onClick={() => {
              track('se_signup__application_working_out_details_logout__fired')
            }}
          />
        </>
      }
      imageName='post-application-info-page'
      infoContent={
        <FormattedMessage
          defaultMessage='We need to check a few more things before providing an offer. Visit the dashboard for updates on your offer status. We’ll also contact you via email when you have an offer ready for review.'
          id='sputnik.WorkingOutDetails__0wLquI'
        />
      }
      marketing={
        <MarketingContent
          image={{
            alt: formatMessage({
              defaultMessage: 'three people standing behind a table with boxes at a possible food drive',
              id: 'sputnik.WorkingOutDetails__4VFaNh',
            }),
            src: 'https://app.divvy.co/assets/stock-photos/credit-application-working-out-details.png',
            isRounded: true,
          }}
          pillText={
            <FormattedMessage
              defaultMessage='Testimonial'
              id='sputnik.WorkingOutDetails__MvBefC'
            />
          }
        >
          <MarketingQuote
            designation={
              <FormattedMessage
                defaultMessage='Ronald McDonald House Charities of Mid-Missouri'
                id='sputnik.WorkingOutDetails__R7D/wB'
              />
            }
            name={
              <FormattedMessage
                defaultMessage='Heather Westenhaver'
                id='sputnik.WorkingOutDetails__SZFzOu'
              />
            }
            quote={
              <FormattedMessage
                defaultMessage='“{BILL_SPEND_AND_EXPENSE} streamlined our credit card entry and reconciliation process, <strong>saved time and simplified receipt procedures</strong>.”'
                id='sputnik.WorkingOutDetails__8CfLdK'
                values={{
                  BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE,
                  strong: (chunks) => <b>{chunks}</b>,
                }}
              />
            }
          />
        </MarketingContent>
      }
      title={
        <FormattedMessage
          defaultMessage="We're still processing your application"
          id='sputnik.WorkingOutDetails__334LMo'
        />
      }
    />
  )
}

export default WorkingOutDetails
